import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import uniqid from "uniqid";
import CryptoJS from "crypto-js";
import { useAuthStore } from "../Store/PersistedStore";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(date) {
  const d = new Date(date);
  const day = d.getDate().toString().padStart(2, "0");
  const month = (d.getMonth() + 1).toString().padStart(2, "0");
  const year = d.getFullYear();
  return `${day}/${month}/${year}`;
}

export function formatApiData(data) {
  const {
    statusto,
    updatecount,
    ismanufacturer,
    issupplier,
    isdistributor,
    ismarketor,
    party_username,
    party_password,
    businesstype,
    emailid,
    phoneno,
    legal_name,
    partyName,
    short_name,
    businesstypeid,
    businesscriteriaid,
    businesscriteria,
    id,
    clc_type,
    ccls_type,
    registration_type,
    gstin,
  } = data;

  const randomNumber = uniqid();
  const hashedPassword = party_password
    ? CryptoJS.MD5(party_password.trim()).toString()
    : "";

  const partyperson = [
    {
      clc_type: clc_type != null ? String(clc_type) : "",
      ccls_type: ccls_type != null ? String(ccls_type) : "",
    },
  ];

  return [
    {
      name: "",
      tables: {
        parameter: [
          {
            enable_multiparty_for_oneaccount: "1",
            statusfrom: "0",
            statusto: statusto !== undefined ? String(statusto) : "1",
          },
        ],
        party: [
          {
            // accountid: "49687",
            enable_multiparty_singleaccount: "1",
            ismanufacturer:
              ismanufacturer !== undefined ? String(ismanufacturer) : "1",
            issupplier: issupplier !== undefined ? String(issupplier) : "1",
            isdistributor:
              isdistributor !== undefined ? String(isdistributor) : "1",
            ismarketor: ismarketor !== undefined ? String(ismarketor) : "1",
            uid: "",
            login_allowed: "1",
            updatecount: "",
            id: id !== undefined && id !== null ? String(id) : "",
            is_allowed_value: "1",
            name:
              partyName !== undefined && partyName !== null
                ? String(partyName)
                : "",
            // partygroup: partygroup !== undefined && partygroup !== null ? String(partygroup) : "",
            phoneno: phoneno !== undefined ? String(phoneno) : "",
            party_username:
              party_username !== undefined && party_username !== null
                ? String(party_username)
                : "",
            party_password: hashedPassword,
            emailid:
              emailid !== undefined && emailid !== null ? String(emailid) : "",
            legal_name:
              legal_name !== undefined && legal_name !== null
                ? String(legal_name)
                : "",
            short_name:
              short_name !== undefined && short_name !== null
                ? String(short_name)
                : "",
            businesstype:
              businesstype !== undefined && businesstype !== null
                ? String(businesstype)
                : "",
            businesstypeid:
              businesstypeid !== undefined && businesstypeid !== null
                ? String(businesstypeid)
                : "",
            businesscriteriaid:
              businesscriteriaid !== undefined && businesscriteriaid !== null
                ? String(businesscriteriaid)
                : "",
            businesscriteria:
              businesscriteria !== undefined && businesscriteria !== null
                ? String(businesscriteria)
                : "",
            constitution_of_business: "7",
            transguid: randomNumber,
            registration_type:
              registration_type !== undefined && registration_type !== null
                ? String(registration_type)
                : "",
            gstin:
              String(registration_type || "") === "1"
                ? ""
                : gstin !== undefined && gstin !== null
                  ? String(gstin)
                  : "",
          },
        ],
        party_contactperson_details: partyperson,
      },
    },
  ];
}

// export function formatApiData2(data) {

//   console.log(data, 'formatApiData ')
//   const {
//     statusto,
//     ismanufacturer,
//     issupplier,
//     party_username,
//     party_password,
//     emailid,
//     phonenumber,
//     legal_name,
//     name,
//     address1,
//     address2,
//     address3,
//     pincode,
//     type,
//     partygroup,
//     hsn,
//     itemname,
//     category,
//     oldrate,
//     rate,
//     taxgroupid,
//     taxrate,
//     ratenet,
//     personname,
//     designation,
//     phoneno,
//     number,
//     email,
//     updatecount,
//     id, ...resData
//   } = data;
//   const randomNumber = uniqid();
//   // const hashedPassword = party_password ? CryptoJS.MD5(party_password.trim()).toString() : '';
//     const hashedPassword = party_password ;

// const partyarray = [
//   {
//     address1: address1 != null ? String(address1) : "",
//     address2: address2 != null ? String(address2) : "",
//     address3: address3 != null ? String(address3) : "",
//     pincode:  pincode  != null ? String(pincode)  : "",
//   }
// ];

// const contactperson = [
//   {
//     personname: personname != null ? String(personname) : "",
//     designation: designation != null ? String(designation) : "",
//     phoneno: number != null ? String(number) : "",
//     email:  email  != null ? String(email)  : "",
//   }
// ];

// console.log(resData?.supplierItems,"resData?.supplierItems");

// const pricelists = resData?.supplierItems

// // const contactperson = resData?.supplierItems

// // const pricelists = [
// //   {
// //     hsn: hsn != null ? String(hsn) : "",
// //     itemname: itemname != null ? String(itemname) : "",
// //     category: category != null ? String(category) : "",
// //     oldrate: oldrate != null ? String(oldrate) : "",
// //     rate: rate != null ? String(rate) : "",
// //     taxgroupid : taxgroupid != null ? String(taxgroupid) : "",
// //     taxrate: taxrate != null ? String(taxrate) : "",
// //     ratenet: ratenet != null ? String(ratenet) : "",

// //   }
// // ]

// console.log(partyarray,"partyarraypartyarray");

//   return [
//     {
//       name: "",
//       tables: {
//         parameter: [{
//           enable_multiparty_for_oneaccount: "1",
//           statusfrom: "1",
//           statusto: statusto !== undefined ? String(statusto) : "1"
//         }],

//         party: [{
//           accountid: "49687",
//           enable_multiparty_singleaccount: "1",
//           ismanufacturer: ismanufacturer !== undefined ? String(ismanufacturer) : "1",
//           issupplier: issupplier !== undefined ? String(issupplier) : "1",
//           uid: "",
//           updatecount: updatecount,
//           id: id !== undefined && id !== null ? String(id) : "",
//           is_allowed_value: "1",
//           name: name !== undefined && name !== null ? String(name) : "",
//           partygroup: partygroup !== undefined && partygroup !== null ? String(partygroup) : "",
//           phoneno: phoneno !== undefined ? String(phoneno) : "",
//           party_username: party_username !== undefined && party_username !== null ? String(party_username) : "",
//           party_password: hashedPassword,
//           emailid: emailid !== undefined && emailid !== null ? String(emailid) : "",
//           legal_name: legal_name !== undefined && legal_name !== null ? String(legal_name) : "",
//           constitution_of_business: "",
//           businesstypeid: type !== undefined && type !== null ? String(type) : "",
//           tradeattached_file: resData?.tradeattached_file ? JSON.stringify(resData?.tradeattached_file) : "",
//           transguid: randomNumber,
//           ...Object.fromEntries(
//             Object.entries(resData)
//               .filter(([key, val]) => val !== undefined && val !== null && key !== 'supplierItems')
//               .map(([key, val]) => [key, String(val)])
//           )
//         }],
//           party_delivery_address:partyarray,
//           party_pricelist:pricelists,
//           party_contactperson_details:contactperson,
//       },

//     }
//   ];
// }

export function formatApiData2(data) {
  const {
    statusto,
    ismanufacturer,
    issupplier,
    party_username,
    party_password,
    emailid,
    legal_name,
    name,
    phoneno,
    address1,
    address2,
    address3,
    pincode,
    stateid,
    delivery_stateid,
    type,
    partygroup,
    branchid,
    barcode,
    itemcode,
    itemid,
    hsn,
    item,
    category,
    oldrate,
    rate,
    taxgroupid,
    taxrate,
    ratenet,
    mrp,
    updatedby,
    value,
    min_pur_qty,
    designation,
    email,
    supplytooutlets,
    updatecount,
    id,
    cid,
    cnumber,
    valid_upto,
    validupto,
    file64format,
    localfilename,
    certificates,
    name_1,
    name_2,
    name_3,
    phoneno_2,
    phoneno_3,

    ...resData
  } = data;

  const randomNumber = uniqid();
  const hashedPassword = party_password;

  const partyname = resData?.partyname ? resData?.partyname : name_3 || "";

  const personname = resData?.personname ? resData?.personname : name_2 || "";

  const partyphoneno = resData?.partyphoneno || phoneno || "";
  const personphoneno = resData?.personphoneno || phoneno || "";

  const partyarray = [
    {
      address1: address1 != null ? String(address1) : "",
      address2: address2 != null ? String(address2) : "",
      address3: address3 != null ? String(address3) : "",
      pincode: pincode != null ? String(pincode) : "",
      stateid:
        delivery_stateid != null
          ? String(delivery_stateid)
          : stateid != null
            ? String(stateid)
            : "",
      // name: personname,
      name: personname != null ? String(personname) : "",
      phoneno: phoneno_2,
    },
  ];

  const contactperson = [
    {
      name: personname,
      designation: designation != null ? String(designation) : "",
      phoneno: phoneno_2,
      email: email != null ? String(email) : "",
      supplytooutlets: "",
    },
  ];

  const normalizeCertificates = (rows) =>
    (Array.isArray(rows) ? rows : [])
      .map((row = {}) => {
        const certificateId =
          row?.certificate_id ?? row?.cid ?? row?.id ?? row?.masterCertId;
        const title = row?.title ?? row?.cnumber ?? row?.number ?? "";
        const validUpto =
          row?.valid_upto ??
          row?.validupto ??
          row?.valid_to ??
          row?.expiry_date ??
          row?.expire_date ??
          row?.expiry ??
          "";
        const certificateKey =
          row?.certificate ?? row?.certificateLabel ?? row?.name ?? "";
        const fileContent =
          row?.file_content ?? row?.file64format ?? row?.fileBase64 ?? "";
        const localFileName =
          row?.localfilename ?? row?.file_name ?? row?.fileName ?? "";

        if (
          (certificateId === undefined ||
            certificateId === null ||
            String(certificateId).trim() === "") &&
          String(title || "").trim() === "" &&
          String(validUpto || "").trim() === "" &&
          String(fileContent || "").trim() === "" &&
          String(localFileName || "").trim() === ""
        ) {
          return null;
        }

        return {
          certificate_id: certificateId != null ? String(certificateId) : "",
          certificate: String(certificateKey || ""),
          title: String(title || ""),
          valid_upto: String(validUpto || ""),
          file_content: String(fileContent || ""),
          localfilename: String(localFileName || ""),
        };
      })
      .filter(Boolean);

  const certificate_master =
    Array.isArray(certificates) && certificates.length > 0
      ? normalizeCertificates(certificates)
      : normalizeCertificates([
          {
            certificate_id: cid,
            cnumber,
            valid_upto: valid_upto ?? validupto ?? "",
            file64format,
            localfilename,
          },
        ]);

  // const certificate_master =
  //   cid && file64format
  //     ? [
  //         {
  //           certificate_id: String(cid),
  //           title: String(cnumber || ""),
  //           file_content: file64format
  //         }
  //       ]
  //     : [];

  console.log(resData?.supplierItems, " gsgsgsgsgsgsg ");
  const pricelists = (resData?.supplierItems || []).map((row = {}) => ({
    ...row,
    item:
      row?.item !== undefined && row?.item !== null && String(row?.item) !== ""
        ? String(row?.item)
        : row?.itemname !== undefined && row?.itemname !== null
          ? String(row?.itemname)
          : "",
    itemname:
      row?.itemname !== undefined &&
      row?.itemname !== null &&
      String(row?.itemname) !== ""
        ? String(row?.itemname)
        : row?.item !== undefined && row?.item !== null
          ? String(row?.item)
          : "",
    itemid: row?.itemid != null ? String(row?.itemid) : "",
    itemcode: row?.itemcode != null ? String(row?.itemcode) : "",
  }));

  console.log(pricelists, "partyarraypartyarray");

  return [
    {
      name: "",
      tables: {
        parameter: [
          {
            enable_multiparty_for_oneaccount: "1",
            statusfrom: "1",
            statusto: statusto !== undefined ? String(statusto) : "1",
          },
        ],

        party: [
          {
            accountid: "49687",
            enable_multiparty_singleaccount: "1",
            ismanufacturer:
              ismanufacturer !== undefined ? String(ismanufacturer) : "1",
            issupplier: issupplier !== undefined ? String(issupplier) : "1",
            uid: "",
            updatecount: updatecount,
            id: id !== undefined && id !== null ? String(id) : "",
            is_allowed_value: "1",
            name: partyname, // This is the party/organization name
            partygroup:
              partygroup !== undefined && partygroup !== null
                ? String(partygroup)
                : "",
            // phoneno: phonenumber !== undefined ? String(phonenumber) :
            //         (phoneno !== undefined ? String(phoneno) : ""),
            phoneno: phoneno_3,
            party_username:
              party_username !== undefined && party_username !== null
                ? String(party_username)
                : "",
            party_password: hashedPassword,
            emailid:
              emailid !== undefined && emailid !== null ? String(emailid) : "",
            legal_name:
              legal_name !== undefined && legal_name !== null
                ? String(legal_name)
                : "",
            stateid:
              stateid !== undefined && stateid !== null ? String(stateid) : "",
            constitution_of_business: "",
            businesstypeid:
              type !== undefined && type !== null ? String(type) : "",
            supplytooutlets:
              supplytooutlets !== undefined && supplytooutlets !== null
                ? String(supplytooutlets)
                : "",
            tradeattached_file: resData?.tradeattached_file
              ? JSON.stringify(resData?.tradeattached_file)
              : "",
            transguid: randomNumber,
            ...Object.fromEntries(
              Object.entries(resData)
                .filter(
                  ([key, val]) =>
                    val !== undefined &&
                    val !== null &&
                    key !== "supplierItems" &&
                    key !== "certificates" &&
                    key !== "valid_upto" &&
                    key !== "validupto" &&
                    key !== "delivery_stateid",
                )
                .map(([key, val]) => [key, String(val)]),
            ),
          },
        ],
        // party_pricelist :[{
        //   barcode: "",
        //   branchid: branchid != null ? String(branchid) : "1",
        //   itemcode: "",
        //   itemid: itemid != null ? String(itemid) : "",
        //   hsn: hsn != null ? String(hsn) : "",
        //   item: item != null ? String(item) : "",
        //   category: category != null ? String(category) : "",
        //   oldrate: oldrate != null ? String(oldrate) : "",
        //   rate: rate != null ? String(rate) : "",
        //   taxgroupid : taxgroupid != null ? String(taxgroupid) : "",
        //   taxrate: taxrate != null ? String(taxrate) : "",
        //   ratenet: ratenet != null ? String(ratenet) : "",
        //   mrp : mrp != null ? String(mrp) : "",
        //   min_pur_qty : min_pur_qty != null ? String(min_pur_qty) : "",
        // }],
        party_delivery_address: partyarray,
        party_pricelist: pricelists,
        party_contactperson_details: contactperson,
        certificates: certificate_master,
      },
    },
  ];
}

export function formatApiData3(data) {
  const {
    statusto,
    ismanufacturer,
    issupplier,
    party_username,
    party_password,
    emailid,
    phoneno,
    legal_name,
    name,
    type,
    partyGroup,
    id,
    status,
    updatecount,
    ...resData
  } = data;

  console.log(data, "formatApiData");

  const randomNumber = uniqid();
  const hashedPassword = party_password
    ? CryptoJS.MD5(party_password.trim()).toString()
    : "";

  return [
    {
      name: "",
      tables: {
        parameter: [
          {
            enable_multiparty_for_oneaccount: "1",
            statusfrom: "1",
            statusto: statusto !== undefined ? String(statusto) : "1",
          },
        ],
        party: [
          {
            accountid: "49687",
            enable_multiparty_singleaccount: "1",
            ismanufacturer:
              ismanufacturer !== undefined ? String(ismanufacturer) : "1",
            issupplier: issupplier !== undefined ? String(issupplier) : "1",
            uid: "",
            updatecount:
              updatecount !== undefined && updatecount !== null
                ? String(updatecount)
                : "",
            id: id !== undefined && id !== null ? String(id) : "",
            is_allowed_value: "1",
            name:
              partyName !== undefined && partyName !== null
                ? String(partyName)
                : "",
            partygroup:
              partyGroup !== undefined && partyGroup !== null
                ? String(partyGroup)
                : "",
            phoneno: phoneno !== undefined ? String(phoneno) : "",
            party_username:
              party_username !== undefined && party_username !== null
                ? String(party_username)
                : "",
            party_password: hashedPassword,
            emailid:
              emailid !== undefined && emailid !== null ? String(emailid) : "",
            legal_name:
              legal_name !== undefined && legal_name !== null
                ? String(legal_name)
                : "",
            constitution_of_business: "7",
            businesstypeid:
              type !== undefined && type !== null ? String(type) : "",
            transguid: randomNumber,
            // ...Object.fromEntries(
            //   Object.entries(resData)
            //     .filter(([_, val]) => val !== undefined && val !== null)
            //     .map(([key, val]) => [
            //       key,
            //       typeof val === "object" ? JSON.stringify(val) : String(val),
            //     ]),
            // ),
          },
        ],
      },
    },
  ];
}
export function formatApproverLoginData({
  username,
  password,
  branchid = "1",
  changePwd = "N",
}) {
  const hashedPassword = CryptoJS.MD5(password.trim()).toString();

  return [
    {
      name: "",
      tables: {
        parameter: [
          {
            branchid: String(branchid),
            change_pwd: String(changePwd),
            pwd: hashedPassword,
            username: username.trim(),
            is_employee: "1",
          },
        ],
      },
    },
  ];
}

export function formatLoginData({
  party_username,
  party_password,
  branchid = "1",
  changePwd = "N",
}) {
  const hashedPassword = CryptoJS.MD5(party_password.trim()).toString();

  return [
    {
      name: "",
      tables: {
        parameter: [
          {
            branchid: String(branchid),
            change_pwd: String(changePwd),
            pwd: hashedPassword,
            username: party_username.trim(),
            is_employee: "0",
          },
        ],
      },
    },
  ];
}

export function formatLogoutData(sessionIdInput) {
  const sessionid = sessionIdInput || localStorage.getItem("approverId") || "";

  return [
    {
      name: "",
      tables: {
        parameter: [
          {
            status: "1",
            sessionid: sessionid,
          },
        ],
      },
    },
  ];
}

export function formatLogoutDatalogin(id) {
  const logoutId = String(
    id ||
      localStorage.getItem("supplierSessionId") ||
      localStorage.getItem("user_id") ||
      localStorage.getItem("SUPPLIER_ID") ||
      "",
  ).trim();

  return [
    {
      name: "",
      tables: {
        parameter: [
          {
            status: "1",
            id: logoutId,
            sessionid: logoutId,
          },
        ],
      },
    },
  ];
}

// 🔹 Create proper ERP body for department list
export const formatGetDataDepartment = () => {
  return [
    {
      name: "inv.item.departmentlist", // method name here
      tables: {
        parameter: [
          {
            searchtext: "%",
          },
        ],
      },
    },
  ];
};

// export function formatGetDeatails({ id }) {

//     const vid = localStorage.getItem("VID");
//     console.log(vid,"sdfghjkjhgfdfcgvh")
//   const menustatus = localStorage.getItem("menustatus");
//   console.log(menustatus,"statatatstststst")

//   return [
//     {
//       name: "",
//       tables: {
//         parameter: [
//           {
//             status: menustatus,
//             id:String(vid)
//           }
//         ]
//       }
//     }
//   ];
// }
// If formatGetData doesn't exist, create it based on your original working code

export function formatGetDatadetails({ id }) {
  return [
    {
      name: "",
      tables: {
        parameter: [
          {
            id: String(id),
          },
        ],
      },
    },
  ];
}

export function formatGetDeatails({ id }) {
  const menustatus =
    localStorage.getItem("menuStatus") ||
    localStorage.getItem("menustatus") ||
    "";

  return [
    {
      name: "",
      tables: {
        parameter: [
          {
            status: menustatus,
            id: String(id),
          },
        ],
      },
    },
  ];
}

export function formatGetstatusid({ id }) {
  if (!id) {
    console.error("No ID provided to formatGetData");
    throw new Error("Supplier ID is required");
  }
  const status = localStorage.getItem("status");
  console.log(status, "statatatstststst");

  return [
    {
      name: "",
      tables: {
        parameter: [
          {
            status: "1",
            id: String(id),
          },
        ],
      },
    },
  ];
}
export function formatGetData({ id, stateid, searchtext } = {}) {
  const userId = localStorage.getItem("user_id");
  const status = localStorage.getItem("status");
  const parameter = {
    status: status,
    id: userId,
  };

  if (stateid !== undefined && stateid !== null && String(stateid) !== "") {
    parameter.stateid = String(stateid);
  }

  if (
    searchtext !== undefined &&
    searchtext !== null &&
    String(searchtext) !== ""
  ) {
    parameter.searchtext = String(searchtext);
  }

  return [
    {
      name: "",
      tables: {
        parameter: [parameter],
      },
    },
  ];
}

export function formatSearchTextData({ searchtext }) {
  return [
    {
      name: "",
      tables: {
        parameter: [
          {
            searchtext: String(searchtext || "").trim(),
          },
        ],
      },
    },
  ];
}
export function formatSearchText({ searchtext, partyid }) {
  return [
    {
      name: "",
      tables: {
        parameter: [
          {
            searchtext: String(searchtext || "").trim(),
            party: partyid,
            basetype: "3",
          },
        ],
      },
    },
  ];
}
export function formatDocumentData(data) {
  const {
    id,
    field_name,
    document_url,
    document_number,
    methodName,
    attachedfiletrade,
    attachedfilefssai,
    attachedfilequality,
    attachedfilegst,
    attachedfilelicence,
    attachedfilelegal,
    attachedfileaudit,
    tradecertificateno,
    fssaicertificateno,
    qualitycertificateno,
    gstcertificateno,
    licencecertificateno,
    legalcertificateno,
    auditcertificateno,
    field,
    attachfile,
    updatecount,
    ...resData
  } = data;
  const randomNumber = uniqid();

  return [
    {
      name: "",
      tables: {
        parameter: [
          {
            enable_multiparty_for_oneaccount: "1",
            statusfrom: "1",
            statusto: "1", // Default status for document updates
          },
        ],

        document: [
          {
            uid: "",
            updatecount: updatecount,
            id: id !== undefined && id !== null ? String(id) : "",
            field_name: field_name !== undefined ? String(field_name) : "",
            document_url:
              document_url !== undefined ? String(document_url) : "",
            document_number:
              document_number !== undefined ? String(document_number) : "",
            transguid: randomNumber,

            tradeattached_file:
              field === "tradeattached_file" && attachfile !== undefined
                ? String(attachfile)
                : "",
            fssaiattached_file:
              field === "fssaiattached_file" && attachfile !== undefined
                ? String(attachfile)
                : "",
            qualityattached_file:
              field === "qualityattached_file" && attachfile !== undefined
                ? String(attachfile)
                : "",
            gstattached_file:
              field === "gstattached_file" && attachfile !== undefined
                ? String(attachfile)
                : "",
            licenceattached_file:
              field === "licenceattached_file" && attachfile !== undefined
                ? String(attachfile)
                : "",
            legalattached_file:
              field === "legalattached_file" && attachfile !== undefined
                ? String(attachfile)
                : "",
            auditattached_file:
              field === "auditattached_file" && attachfile !== undefined
                ? String(attachfile)
                : "",

            tradecertificateno:
              tradecertificateno !== undefined
                ? String(tradecertificateno)
                : "",
            fssaicertificateno:
              fssaicertificateno !== undefined
                ? String(fssaicertificateno)
                : "",
            qualitycertificateno:
              qualitycertificateno !== undefined
                ? String(qualitycertificateno)
                : "",
            gstcertificateno:
              gstcertificateno !== undefined ? String(gstcertificateno) : "",
            licencecertificateno:
              licencecertificateno !== undefined
                ? String(licencecertificateno)
                : "",
            legalcertificateno:
              legalcertificateno !== undefined
                ? String(legalcertificateno)
                : "",
            auditcertificateno:
              auditcertificateno !== undefined
                ? String(auditcertificateno)
                : "",

            ...Object.fromEntries(
              Object.entries(resData)
                .filter(([_, val]) => val !== undefined && val !== null)
                .map(([key, val]) => [key, String(val)]),
            ),
          },
        ],
      },
    },
  ];
}

export function mapPartyItemsResponse(serverItems = []) {
  return serverItems.map((item) => ({
    hsn: item.hsnid || "",
    item: item.itemid || "",
    itemcode: item.itemcode || "",
    itemid: item.itemid || "", // backend id
    category: item.categoryid || "",
    pur_unit: item.pur_unit || "",
    min_pur_qty: item.min_pur_qty || "",
    rate: item.rate || "",
    taxgroupid: item.taxgroupid || "",
  }));
}

export const validateFile = (file) => {
  const validTypes = [
    "application/pdf",
    "image/jpeg",
    "image/png",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ];

  const maxSize = 5 * 1024 * 1024; // 5MB

  if (!validTypes.includes(file.type)) {
    throw new Error("Only PDF, JPG, PNG, and DOC/DOCX files are allowed");
  }

  if (file.size > maxSize) {
    throw new Error("File size must be less than 5MB");
  }

  return true;
};

export function mergeObjectsCustom(...objects) {
  const result = {};
  let nameIndex = 1;
  let phonenoIndex = 1;

  for (const obj of objects) {
    for (const key in obj) {
      let value = obj[key];

      // Skip undefined, null, empty string
      const hasValue = value !== undefined && value !== null && value !== "";

      let resultKey = key;

      // Special handling for "name" key: always create name_1, name_2, name_3, etc.
      if (key === "name") {
        resultKey = `name_${nameIndex}`;
        nameIndex++;
      }

      // Special handling for "phoneno" key: always create phoneno_1, phoneno_2, etc.
      if (key === "phoneno") {
        resultKey = `phoneno_${phonenoIndex}`;
        phonenoIndex++;
      }

      // If result doesn't have this key yet → directly assign
      if (!(resultKey in result)) {
        result[resultKey] = hasValue ? value : "";
      } else {
        // result already has this key
        const resultHasValue =
          result[resultKey] !== undefined &&
          result[resultKey] !== null &&
          result[resultKey] !== "";

        // If result does not have value but new object has value → take it
        if (!resultHasValue && hasValue) {
          result[resultKey] = value;
        }
        // If result already has valid value → ignore further values (first value wins)
      }
    }
  }
  console.log("testmerger", result);

  return result;
}
/**
 * Given an array of objects, group them by the value of their "name" property.
 * Returns an object where each key is a name and the value is an array of objects with that name.
 * Example:
 *   groupByName([{name: "A", x: 1}, {name: "B", x: 2}, {name: "A", x: 3}])
 *   // => { A: [{name: "A", x: 1}, {name: "A", x: 3}], B: [{name: "B", x: 2}] }
 */
export function groupByName(arr) {
  return arr.reduce((acc, obj) => {
    const key = obj.name || "";
    if (!acc[key]) acc[key] = [];
    acc[key].push(obj);
    return acc;
  }, {});
}
export function formatPasswordResetData(oldPassword, resetPassword, username) {
  const hashedOldPassword = CryptoJS.MD5(
    String(oldPassword || "").trim(),
  ).toString();
  const hashedNewPassword = CryptoJS.MD5(
    String(resetPassword || "").trim(),
  ).toString();
  return [
    {
      name: "",
      tables: {
        parameter: [
          {
            oldpwd: hashedOldPassword,
            newpwd: hashedNewPassword,
            username: String(username || "").trim(),
          },
        ],
      },
    },
  ];
}
